import LockTableRow from "./LockTableRow";
import DateCellRenderer from "../renderers/DateCellRenderer";
import EmptyCellRenderer from "../renderers/EmptyCellRenderer";

export default class DatesRow extends LockTableRow {
    constructor(weekDayNames) {
        super();
        this.cellRenderer = new DateCellRenderer(weekDayNames);
    }

    createRowHeaderRenderer() {
        return new EmptyCellRenderer();
    }

    createLockCellRenderer() {
        return this.cellRenderer;
    }

    accept(visitor, cell) {
        return visitor.visitDatesRow(cell);
    }

    updateSelectionMarks(updateRegion) {
        for (let colIdx = updateRegion.colMin; colIdx <= updateRegion.colMax; colIdx++) {
            let cell = this.getCell(colIdx);
            cell.getRenderer().updateSelectionMarks(cell);
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/DatesRow.js